import { useSubmitButton } from "Atoms/Buttons";

import { useVenue } from "@onsite_app/MobileOrderingMenu/VenueContext";
import { getVenueHasTablePay } from "@onsite_app/MobileOrderingMenu/venueSelectors";

import { createTabCheckoutSession } from "../Cart/requests";
import { useSession } from "../Session/SessionContext";

export const useStartTabCheckoutSession = () => {
  const [submissionState, trackSubmit] = useSubmitButton();
  const session = useSession();
  const venue = useVenue();
  const hasTablePay = getVenueHasTablePay(venue);

  const startTabCheckoutSession = async () => {
    const customerTab = session.customerTab;
    if (!customerTab?.uuid) {
      throw "Can't make payment on unsaved customer tab";
    }
    if (!hasTablePay) {
      console.error("Ordering is not enabled");
      return;
    }
    const checkoutUrl = await createTabCheckoutSession(customerTab.uuid);
    window.location.assign(checkoutUrl);
    await new Promise((r) => setTimeout(r, 3000));
  };

  return {
    startTabCheckoutSession: trackSubmit(startTabCheckoutSession),
    submissionState,
  };
};
